import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { SqlService } from "../../Database/sql.service";

import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-edit-agent',
  templateUrl: './edit-agent.component.html',
  styleUrls: ['./edit-agent.component.css']
})
export class EditAgentComponent implements OnInit {



  constructor(private dbService: SqlService, private route: ActivatedRoute, private router: Router, private modalService: NgbModal) { }

  Name = "";
  Surname = "";
  CellNo = "";
  ID = "";
  Code = "";
  DistributorsKey = "";

  data = [
    {
      ID: "",
      Province: "",
      Active: "",
      DistributorsKey: "",
    }];
  Distributor = "";
  Distributors = [{ label: "", ID: "" }];

  Province = "";
  Provinces = [""];
  Areas = [{ label: '', ID: '' }];
  Area = '';

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      let temp = params.get('ID')?.toString();
      if (temp) {
        this.ID = temp;
        this.getData(temp);
      }

    });

  }

  getData(ID: any) {
    Swal.fire({
      title: 'Loading details of agent',
      showConfirmButton: false,
      toast: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
      willOpen: () => {
        Swal.showLoading();
      }
    });

    this.dbService.GetSpecificAgent(ID).subscribe((ret: any) => {
      if (ret != "false") {

        let a = (ret as string).split(';');
        a.splice(a.length - 1, 1);

        a.forEach(element => {
          let elementtemp = element.split(",")
          this.Name = elementtemp[0];
          this.Surname = elementtemp[1];
          this.CellNo = elementtemp[2];
          //this.ID= elementtemp[3];
          this.Code = elementtemp[4];
          this.DistributorsKey = elementtemp[5];
          // optional iAreaUniqueCode returned as elementtemp[6]

          this.Area = elementtemp[6];

        });


        this.dbService.getAllDistrubutor().subscribe((ret: any) => {
          if (ret != "false") {
            this.Distributors.splice(0);
            this.Provinces.splice(0);
            this.data.splice(0);

            let a = (ret as string).split(';');
            a.splice(a.length - 1, 1);

            a.forEach(element => {
              let elementtemp = element.split(",")

              if (elementtemp[2] == "Yes") {
                let temp = {
                  ID: elementtemp[0],
                  Province: elementtemp[1],
                  Active: elementtemp[2],
                  DistributorsKey: elementtemp[3]
                }

                this.data.push(temp);
                if (!(this.Provinces.includes(elementtemp[1]))) {
                  this.Provinces.push(elementtemp[1]);
                }
              }
            });

            if (this.DistributorsKey != null) {
              let tempDist = this.data.find((x) => x.DistributorsKey == this.DistributorsKey)
              if (tempDist != undefined) {
                this.Province = tempDist.Province;
                this.data.forEach(element => {
                  if (element.Province == this.Province) {
                    this.Distributors.push({ label: element.ID, ID: element.DistributorsKey });
                  }
                });
                this.Distributor = tempDist.DistributorsKey;
                // load Areas for this province
                this.dbService.getAreasWithIdPerProvince(this.Province).subscribe((ret: any) => {
                  if (ret != 'false') {
                    this.Areas.splice(0);
                    let a = (ret as string).split(';');
                    a.splice(a.length - 1, 1);
                    a.forEach(element => {
                      let elementtemp = element.split(',');
                      this.Areas.push({ label: elementtemp[0], ID: elementtemp[1] });
                    });
                    // If agent had a saved iAreaUniqueCode, ensure it's selected in the dropdown
                    if (this.Area && this.Area !== '') {
                      const found = this.Areas.find(x => x.ID == this.Area);
                      if (!found) {
                        // area not found in this province, clear
                        this.Area = '';
                      }
                    }
                  }
                });
              }
            }

            Swal.close();
          } else {
            this.PopupTitle = "Error"
            this.DisplayErrormessage = "Please check your internet connection and try again";
            let element: HTMLButtonElement = document.getElementById('ErrorButton') as HTMLButtonElement;
            element.click();
            Swal.close();
          }
        });
      } else {
        this.PopupTitle = "Error"
        this.DisplayErrormessage = "Please check your internet connection and try again";
        let element: HTMLButtonElement = document.getElementById('ErrorButton') as HTMLButtonElement;
        element.click();
        Swal.close();
      }
    });
  }

  ProvinceChanged() {
    this.Area = '';
    this.Distributor = '';

    this.Distributors.splice(0);
    this.data.forEach(element => {
      if (element.Province == this.Province) {
        this.Distributors.push({ label: element.ID, ID: element.DistributorsKey });
      }
    });

    // Load areas by province (returns Area, iUniqueAutoNumber pairs)
    this.Areas.splice(0);
    if (this.Province && this.Province !== '') {
      this.dbService.getAreasWithIdPerProvince(this.Province).subscribe((ret: any) => {
        if (ret != 'false') {
          let a = (ret as string).split(';');
          a.splice(a.length - 1, 1);
          a.forEach(element => {
            let elementtemp = element.split(',');
            this.Areas.push({ label: elementtemp[0], ID: elementtemp[1] });
          });
        }
      });
    }
  }


  Delete() {
    this.dbService.DeleteAgent(this.ID).subscribe((ret: any) => {
      if (!(String(ret).includes("Error"))) {
        this.PopupTitle = "Success"
        this.DisplayErrormessage = "The Agent has been deleted";
        let element: HTMLButtonElement = document.getElementById('ErrorButton') as HTMLButtonElement;
        element.click();
        this.Back();
      } else {
        if ((String(ret).includes("Duplicate entry")) || (String(ret).includes("duplicate key"))) {
          this.PopupTitle = "Invalid Details"
          this.DisplayErrormessage = "This Agent already exists";
          let element: HTMLButtonElement = document.getElementById('ErrorButton') as HTMLButtonElement;
          element.click();
        } else {
          this.PopupTitle = "Something went wrong"
          this.DisplayErrormessage = "Something went wrong, please try again. If this continues please contact the I.T Department";
          let element: HTMLButtonElement = document.getElementById('ErrorButton') as HTMLButtonElement;
          element.click();
        }
      }
    });
  }

  async Save() {
    var formData = new FormData();

    formData.set('ID', this.ID);
    formData.set('Name', this.Name);
    formData.set('Surname', this.Surname);
    formData.set('CellNo', this.CellNo);
    formData.set('uCode', this.Code);
    formData.set('DistributorID', this.Distributor);
    formData.set('AreaUnique', this.Area);

    await (this.dbService.EditAgentName(formData).subscribe((ret: any) => {
      if (!(String(ret).includes("Error"))) {
        this.PopupTitle = "Success"
        this.DisplayErrormessage = "The Agent has been editted";
        let element: HTMLButtonElement = document.getElementById('ErrorButton') as HTMLButtonElement;
        element.click();
        this.Back();
      } else {
        if ((String(ret).includes("Duplicate entry")) || (String(ret).includes("duplicate key"))) {
          this.PopupTitle = "Invalid Details"
          this.DisplayErrormessage = "This Agent already exists";
          let element: HTMLButtonElement = document.getElementById('ErrorButton') as HTMLButtonElement;
          element.click();
        } else {
          this.PopupTitle = "Something went wrong"
          this.DisplayErrormessage = "Something went wrong, please try again. If this continues please contact the I.T Department";
          let element: HTMLButtonElement = document.getElementById('ErrorButton') as HTMLButtonElement;
          element.click();
        }

      }
    }));
  }

  Reset() {
    this.Name = "";
    this.Surname = "";
    this.CellNo = "";
    this.Code = "";
    this.Distributor = "";
    this.Province = "";
  }

  Back() {
    this.router.navigate(['ViewAgent']);
  }

  closeResult = '';
  DisplayErrormessage = "";
  PopupTitle = "";
  open(content: any) {
    this.modalService.open(content,
      { ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
        this.closeResult = `Closed with: ${result}`;
      }, (reason) => {
        this.closeResult =
          `Dismissed ${this.getDismissReason(reason)}`;
      });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

}
